attendeeList.controller('attendeeCtrl', [
    '$rootScope',
    '$scope',
    '$window',
    '$timeout',
    'growlService',
    'logService',
    'socketService',
    'storageService',
    'cookieService',
    'attendeeService',
    'meetingService',
    'helperService',
    'phoneConferenceService',
    '$filter',
    'analyticsWrapperService',
    'notificationService',
    'attendeeListService',
    'contentService',
    'annotationService',
    'connectivityService',
    'supportLinkService',
    'localizationService',
    'brandingService',
    'desktopNotificationService',
    'joinRequestNotificationService',
    'handRaiseService',
    'configService',
    'attendeeListStateService',
    'subscriptionService',
    'userPairStateService',
    'modalHelperService',
    function (
        $rootScope,
        $scope,
        $window,
        $timeout,
        growlService,
        logService,
        socketService,
        storageService,
        cookieService,
        attendeeService,
        meetingService,
        helperService,
        phoneConferenceService,
        $filter,
        analyticsWrapperService,
        notificationService,
        attendeeListService,
        contentService,
        annotationService,
        connectivityService,
        supportLinkService,
        localizationService,
        brandingService,
        desktopNotificationService,
        joinRequestNotificationService,
        handRaiseService,
        configService,
        attendeeListStateService,
        subscriptionService,
        userPairStateService,
        modalHelperService
    ) {
        const self = this;

        const logger = new LogServiceWrapper(logService, 'attendeeCtrl');
        // quality configurations done by user from url parameter
        let qualityBarsConfig = {};
        // contains metrics causing quality degradation for each attendee
        // that is shown in tooltip, tooltip gets updated on change of this object
        let qualityBarsDataLastReceived = {};
        self.attendees = [];
        self.invitedAttendees = [];
        self.attendantId = attendeeService.getAttendantId();
        self.inviteOpen = false;
        self.invite = {
            meetingLink: '',
            visibleMeetingLink: '',
            meetingPhoneNumber: ''
        };
        self.selfDisplayName = localizationService.translate('COMMON.YOU_TEXT');
        self.verifiedAttendeeText = localizationService.translate('ATTENDEE_LIST.ATTENDEE_VERIFIED');
        self.unverifiedAttendeeText = localizationService.translate('ATTENDEE_LIST.ATTENDEE_UNVERIFIED');
        self.loggedInAttendeeText = localizationService.translate('ATTENDEE_LIST.ATTENDEE_LOGGED_IN_VIA_MEETING_APP');
        self.notLoggedInAttendeeText = localizationService.translate(
            'ATTENDEE_LIST.ATTENDEE_NOT_LOGGED_IN_VIA_MEETING_APP'
        );

        self.getAttendees = getAttendees;
        self.orderByHostsOnTopThenAlpha = orderByHostsOnTopThenAlpha;
        self.phoneCallerDisplayName = localizationService.translate('COMMON.PHONE_CALLER');
        self.getPhoneCallerDisplayName = getPhoneCallerDisplayName;
        self.isNodeDisconnected = false;

        self.toggleAttendeeAudio = toggleAttendeeAudio;
        self.openInvites = openInvites;
        self.emailInviteClick = emailInviteClick;
        self.copyInviteToClipboard = copyInviteToClipboard;
        self.copyTextToClipboard = copyTextToClipboard;
        self.kickAttendee = kickAttendee;
        self.canKickAttendee = canKickAttendee;
        self.isKickOptionEnabled = isKickOptionEnabled;

        //Tooltip Functions
        self.getAudioStatusTooltip = getAudioStatusTooltip;
        self.getIndicatorTooltip = getIndicatorTooltip;
        self.getWebcamTooltip = getWebcamTooltip;
        self.getIceConnectivityTooltip = getIceConnectivityTooltip;

        self.getConnectivityIconState = getConnectivityIconState;
        self.getConnectivityClass = getConnectivityClass;

        self.isAttendeeSelf = isAttendeeSelf;
        self.isMicEnabled = isMicEnabled;
        self.isAttendeeConnected = isAttendeeConnected;
        self.getAttendeeConnectionState = getAttendeeConnectionState;
        self.getAttendeeConnectingTooltip = getAttendeeConnectingTooltip;

        //TODO: REMOVE POST-REDESIGN
        //Attendees Join with Audio Muted
        self.joinAudioMuted = meetingService.getJoinAudioMuted();
        self.isJoinAudioMutedInitialized = isJoinAudioMutedInitialized;

        //TODO: REMOVE POST-REDESIGN
        self.playEntryExitSounds = true;
        self.isPlayEntryExitSoundsInitialized = false;
        self.canTogglePlayEntryExitSounds = canTogglePlayEntryExitSounds;
        self.getPlayEntryExitSoundsTooltip = getPlayEntryExitSoundsTooltip;
        self.togglePlayEntryExitSounds = togglePlayEntryExitSounds;

        self.isWebinar = meetingService.isWebinar;
        self.onAirModeUpdating = false;
        self.getPromoteBlockedTooltip = getPromoteBlockedTooltip;
        self.getReactionCounts = getReactionCounts;
        self.getMeetingType = getMeetingType;

        //Full Contact Info
        self.toggleDropdown = toggleDropdown;
        self.dropdownId = 0;

        self.hasProfileCardsEnabled = hasProfileCardsEnabled;
        self.hideProfileCardTooltip = hideProfileCardTooltip;
        self.restoreProfileCardTooltip = restoreProfileCardTooltip;

        self.hasPromoteDemoteFunctionality = hasPromoteDemoteFunctionality;
        self.promote = promote;
        self.demote = demote;
        self.isPromoteBlocked = isPromoteBlocked;

        self.showVirtualAssistantMessage = showVirtualAssistantMessage;
        self.removeVirtualAssistant = removeVirtualAssistant;
        self.virtualAssistantClicked = virtualAssistantClicked;

        self.getInvitedStatus = getInvitedStatus;

        self.isMutingOthersAllowed = isMutingOthersAllowed;
        self.isUnmutingSelfAllowed = isUnmutingSelfAllowed;
        self.getEmailInviteTooltip = getEmailInviteTooltip;
        self.getCopyToClipboardTooltip = getCopyToClipboardTooltip;

        self.getCallerAssignment = getCallerAssignment;
        self.shouldShowJoinRequestList = shouldShowJoinRequestList;
        self.getJoinRequests = getJoinRequests;
        self.onNodeDisconnected = onNodeDisconnected;
        self.onNodeReconnected = onNodeReconnected;

        self.hasFavoritesEnabled = hasFavoritesEnabled;
        self.attendeeFavoritesList = {};

        self.getFavoriteList = getFavoriteList;
        self.shouldShowHandRaiseCounter = shouldShowHandRaiseCounter;

        self.isInCompactMode = false;
        self.disableJoinRequestInProgress = false;
        self.acceptAllJoinRequestsInProgress = false;

        self.showAttendeeWithEchoDetectedModal = showAttendeeWithEchoDetectedModal;

        self.toggleAttendeeFavorite = toggleAttendeeFavorite;
        self.broadcastToggleAttendeeAsFavoriteEvent = broadcastToggleAttendeeAsFavoriteEvent;
        self.canTurnOffScreenshare = canTurnOffScreenshare;
        self.turnOffScreenshare = turnOffScreenshare;
        self.canTurnOffWebcam = canTurnOffWebcam;
        self.turnOffWebcam = turnOffWebcam;
        self.getMuteAllTooltip = getMuteAllTooltip;
        self.audioMuteAll = audioMuteAll;
        self.onUrlInfoContainerClick = onUrlInfoContainerClick;
        self.onPhoneInfoContainerClick = onPhoneInfoContainerClick;

        self.modalsAvailable = false;
        self.rootSubscription = undefined;

        // saves tooltip string for each attendee
        self.attendeeQualityTooltip = {};
        var qualityBarAutoHideTimers = [];
        $scope.$on('close-profile-dropdown', onCloseProfileDropdown);
        $scope.$on('on-air-mode-updating', onOnAirModeUpdating);
        $scope.$on('on-air-mode-updated', onOnAirModeUpdated);
        $scope.$on('promoted-to-presenter', digest);
        $scope.$on('demoted-to-attendee', digest);
        $scope.$on('update-local-join-audio-muted', onUpdateLocalJoinAudioMuted);
        $scope.$on('play-entry-exit-sounds-updated', onPlayEntryExitSoundsUpdated);
        $scope.$on('attendee-list-updated', onAttendeeListUpdated);
        $scope.$on('invited-attendee-list-updated', onInvitedAttendeeListUpdated);
        $scope.$on('copy-text-to-clipboard', onCopyTextToClipboard);

        $scope.$on('screenshare-started', onScreenShareStarted);
        $scope.$on('screenshare-ended', onScreenShareEnded);
        $scope.$on('update-local-meeting-locked', digest);
        $scope.$on('on-join-requests-update', onJoinRequestsUpdate);
        $scope.$on('on-join-request-avatar-update', digest);
        $scope.$on('on-join-request-updated', digest);

        $scope.$on('muted-with-echo', onAttendeeAudioEcho);
        $scope.$on('attendee-echo-detected', onAttendeeEchoDetected);
        $scope.$on('node-disconnected', onNodeDisconnected);
        $scope.$on('node-reconnected', onNodeReconnected);

        //These digest events are to trigger the directive 'ellipses-shorten' on each attendee name
        //If names are too long while content/rc icons are displayed, the directive will shorten the name with an ellipses
        $scope.$on('content-playing', digest);
        $scope.$on('content-stopped', digest);

        $scope.$on('copy-invitation-text', copyInviteToClipboard);
        $scope.$on('mail-invitation', emailInviteClick);

        $scope.$on('enable-compact-mode', onCompactModeReceived);

        // ipc-vr-message
        $scope.$on('ipc-mute-all', audioMuteAll);
        $scope.$on('ipc-toggle-attendee-audio', toggleAttendeeAudioById);

        $scope.$on('update-attendees-quality', onUpdateAttendeesQuality);

        $scope.$on('set-qualitybars-config', setQualityBarsConfig);
        $scope.$on('toggle-left-sidebar', showQualityBarsForAllAttendees);
        init();

        ////////////////////////

        function init() {
            logService.log('init attendeeCtrl');

            self.invite.meetingLink = meetingService.getAttendeeLoginUrl();
            self.invite.visibleMeetingLink = getVisibleAttendeeLoginUrl(self.invite.meetingLink);

            var info = phoneConferenceService.getPhoneData();
            var phoneNumberRaw = info.phoneNumberFree || info.phoneNumberToll;
            self.invite.meetingPhoneNumberPresenter =
                phoneNumberRaw +
                ' ' +
                localizationService.translate('ATTENDEE_LIST.PIN', { param: ' ' + info.presenterPIN + '#' });
            self.invite.meetingPhoneNumberAttendee =
                phoneNumberRaw +
                ' ' +
                localizationService.translate('ATTENDEE_LIST.PIN', { param: ' ' + info.attendeePIN + '#' });

            self.invite.meetingPhoneNumber = phoneNumberRaw;
            self.invite.meetingPresenterPIN = info.presenterPIN + '#';
            self.invite.meetingAttendeePIN = info.attendeePIN + '#';

            //Retrieve initial attendee-list
            attendeeListService.retrieveListFromServer();
            attendeeListService.retrieveInvitedListFromServer();
            getPlayEntryExitSoundStatus();
            getAnnotationStatus();
            self.getFavoriteList();

            self.rootSubscription = subscriptionService.createSubscription();
            self.rootSubscription.add(
                userPairStateService.modalsAvailable$.subscribe(next => {
                    self.modalsAvailable = next;
                })
            );
        }

        // This function is needed for attendee. For PSTN we show stub 'Phone Caller' by default.
        // For Host we always show PSTN's screen name, which is the phone number first. Server may send real name of PSTN if found.
        // In case of real name, we change the 'screenName' property and email will not be equal screenName more.
        function getPhoneCallerDisplayName(attendee) {
            if (attendee.email === attendee.screenName) {
                return self.phoneCallerDisplayName;
            }

            return attendee.screenName;
        }

        function getFavoriteList() {
            if (cookieService.getObject('attendee-favorites-' + meetingService.getMeetingCode())) {
                self.attendeeFavoritesList = cookieService.getObject(
                    'attendee-favorites-' + meetingService.getMeetingCode()
                );
                attendeeListStateService.favoritesList = self.attendeeFavoritesList;
            }
        }

        function onAttendeeAudioEcho(evt, data) {
            analyticsWrapperService.eventTrack('Meeting - Attendee List - Attendee muted due to echo');

            const isPhonePairedUser = attendeeService.getIsPhonePaired();

            const promptTitle = localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.MUTED_BY_ECHO_TITLE_NEW');
            let promptMsg = localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.MUTED_BY_ECHO_PROMPT_NEW');
            promptMsg +=
                '<br/><ul><li>' +
                localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.ECHO_DETECTION_REDUCE_VOLUME') +
                '</li><li>' +
                localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.ECHO_DETECTION_CHANGE_DEVICE') +
                '</li>';
            if (!isPhonePairedUser) {
                promptMsg +=
                    '<li>' +
                    localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.ECHO_DETECTION_SWITCH_TO_PHONE') +
                    '</li>';
            }
            promptMsg +=
                '<li>' +
                localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.ECHO_DETECTION_CHECK_ANOTHER_DEVICE') +
                '</li></ul>';

            const promptImageUrl = !isPhonePairedUser
                ? 'img/redesign/modal/pop-up-pic-mute.svg'
                : 'img/redesign/modal/pop-up-pic-mute-phone.svg';

            const closeButtonHtml =
                '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
            const swalOpts = {
                title: closeButtonHtml + promptTitle,
                text: promptMsg,
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonColor: brandingService.getBaseColor(),
                confirmButtonText: localizationService.translate('COMMON.CLOSE_TEXT'),
                allowOutsideClick: false,
                html: true,
                imageUrl: promptImageUrl,
                customClass: 'echo-detection-notification-modal'
            };
            if (!helperService.getVDIRef().showContentsOnTopOfVideo) {
                $rootScope.$broadcast('vdi-toggle-preview-video-visibility', true);
            }
            if (!self.isInCompactMode) {
                $window.swal(swalOpts, function (confirmed) {
                    if (!helperService.getVDIRef().showContentsOnTopOfVideo) {
                        $rootScope.$broadcast('vdi-toggle-preview-video-visibility', false);
                    }
                });
            }

            notificationService.tryShowDesktopNotification(promptTitle);
        }

        function onAttendeeEchoDetected(evt, data) {
            if (!attendeeService.getIsHost()) {
                return;
            }

            analyticsWrapperService.eventTrack(`Meeting - Attendee List - Echo detected for attendee`);
            logService.log(`onAttendeeEchoDetected - echo detected for ${data.attendantId}`);
            if (!meetingService.getEchoDetectionEnabled()) {
                logService.log(`onAttendeeEchoDetected - cannot proceed because setting is disabled`);
                return;
            }

            const attendee = attendeeListService
                .getAttendeeList()
                .find(attendee => attendee.attendantId === data.attendantId);
            if (!attendee) {
                logService.log(
                    `onAttendeeEchoDetected - cannot process attendee with attendantId: ${data.attendantId}. Attendee is missing in attendeeList`
                );
                return;
            }

            if (self.isInCompactMode) {
                desktopNotificationService.show(
                    localizationService.translate('HEADER.SETTINGS.ECHO_DETECTION.DIALOG.TITLE', {
                        attendeeName: attendee.screenName
                    }),
                    'echo-detection',
                    '',
                    function () {
                        $rootScope.$broadcast('enable-compact-mode', false);
                        self.showAttendeeWithEchoDetectedModal(attendee);
                    }
                );
            } else {
                self.showAttendeeWithEchoDetectedModal(attendee);
            }
        }

        function hasFavoritesEnabled() {
            return meetingService.getAttendeeFavoritesEnabled();
        }

        function shouldShowJoinRequestList() {
            return (
                meetingService.isMeeting() &&
                attendeeService.getIsHost() &&
                meetingService.getLocked() &&
                meetingService.getJoinRequests().length > 0 &&
                meetingService.getAllowJoinRequests() &&
                !self.disableJoinRequestInProgress
            );
        }

        function onJoinRequestsUpdate(e, data) {
            digest();

            if (data && data.added) {
                showNewJoinRequestDesktopNotification(data.joinRequest.attendeeName);
            }
        }

        function showNewJoinRequestDesktopNotification(attendeeName) {
            if (notificationService.canShowDesktopNotification()) {
                desktopNotificationService.show(
                    localizationService.translate(
                        'JOIN_REQUEST_LIST.DESKTOP_NOTIFICATIONS.ATTENDEE_WANTS_JOIN_TO_MEETING',
                        { person: attendeeName }
                    ),
                    'join-request-list'
                );
            }
        }

        function getJoinRequests() {
            return meetingService.getJoinRequests();
        }

        function onScreenShareStarted() {
            if (
                !meetingService.isWebinar() &&
                annotationService.getIsAnnotationEnabled() &&
                annotationService.getCanHostAnnotation()
            ) {
                if (
                    !contentService.getIsFilePlay() &&
                    self.attendantId === contentService.getContentOwner() &&
                    (!contentService.getIsSharingAppScreen() ||
                        (contentService.getIsSharingAppScreen() &&
                            helperService.isUniteSupportFeature('borderAroundSharedApp')))
                ) {
                    annotationService.createAnnotationWindow().then(function () {
                        annotationService.setIsInitiator(true);
                    });
                }
            }
        }

        function getAttendees() {
            return self.attendees.concat(self.invitedAttendees);
        }

        function onScreenShareEnded() {
            if (annotationService.getIsAnnotationEnabled()) {
                if (annotationService.getCanHostAnnotation()) {
                    annotationService.stopAnnotation();
                } else {
                    annotationService.setIsInSession(false);
                    annotationService.setIsSuspended(false);
                    annotationService.resetButtonLocation();
                }
            }
        }

        function onInvitedAttendeeListUpdated(e, data) {
            self.invitedAttendees = attendeeListService.getInvitedAttendeeList();
            digest();
        }

        function onAttendeeListUpdated(e, data) {
            self.attendees = attendeeListService.getAttendeeList();
            digest();
        }

        function getAnnotationStatus() {
            if (self.getMeetingType() === 'meeting') {
                requestAnnotationStatus();
            }
        }

        function requestAnnotationStatus() {
            var msg = {};
            msg.message = 'sa-enabled';
            msg.callback = function (result) {
                logService.log('requestAnnotationStatus result from meeting server', result);

                if (result) {
                    if (result.suspended) {
                        annotationService.setIsSuspended(true);
                    }

                    annotationService.setSharerSupportsAnnotation(result.sharerSupportsAnnotation);
                }
            };
            socketService.send(msg);
        }

        function getPlayEntryExitSoundStatus() {
            var msgObj = {};
            msgObj.message = 'get-play-entry-exit-sounds';
            msgObj.callback = function (result) {
                logService.log('getPlayEntryExitSounds result received from meeting server', result);
                if (result) {
                    self.playEntryExitSounds = result.playEntryExitSounds;
                    self.isPlayEntryExitSoundsInitialized = true;
                    digest();
                }
            };
            socketService.send(msgObj);
        }

        function getInvitedStatus(attendee) {
            if (attendee.attendeeType != 'invite') {
                return '';
            }

            if (!attendee.responseStatus) {
                return localizationService.translate('ATTENDEE_LIST.INVITED_STATUS');
            }

            switch (attendee.responseStatus) {
                case 'accepted':
                    return localizationService.translate('ATTENDEE_LIST.ACCEPTED_STATUS');
                case 'declined':
                    return localizationService.translate('ATTENDEE_LIST.DECLINED_STATUS');
                case 'tentative':
                    return localizationService.translate('ATTENDEE_LIST.TENTATIVE_STATUS');
            }

            return localizationService.translate('ATTENDEE_LIST.INVITED_STATUS');
        }

        // for Rooms
        function toggleAttendeeAudioById(_, attendantId) {
            const attendee = self.getAttendees().find(attendee => attendee.attendantId === attendantId);

            if (attendee) {
                self.toggleAttendeeAudio(attendee);
            }
        }

        function toggleAttendeeAudio(attendee) {
            if (!helperService.browserHasWebRTC()) {
                return;
            }

            if (attendee.audioDisconnected) {
                return;
            }

            if (self.isWebinar() && !attendeeService.getIsPresenter()) {
                return;
            }
            if (self.onAirModeUpdating) {
                return;
            }
            if (!self.isAttendeeConnected(attendee)) {
                return;
            }

            var micAvailable = attendee.devicePermissions.audioAllowed;
            //TODO: After next mobile release (version 2.1.5),
            //we can remove the check for isMobileAppUser
            if (attendee.deviceConnections && !attendee.isMobileAppUser) {
                if (attendee.devicePermissions.audioAllowed) {
                    //Only care about audioConnected state if audio device permissions are allowed
                    micAvailable = attendee.deviceConnections.audioConnected;
                }
            }

            if (micAvailable || attendee.isPhoneUser || attendee.phoneMemberId) {
                if (!attendee.isSelfMuted) {
                    //If attendee not muted, anyone can mute them

                    if (self.isAttendeeSelf(attendee)) {
                        attendeeService.toggleAudio(attendee.attendantId);
                        analyticsWrapperService.eventTrack('Meeting - Attendee List - Talk Mute');
                        return;
                    }

                    // Check security setting
                    if (self.isMutingOthersAllowed() === false) {
                        return;
                    }

                    var attendeeName = $filter('phoneFilter')(attendee.screenName);

                    if (attendee.isPhoneUser) {
                        if (!attendeeService.getIsPresenter()) {
                            attendeeName = localizationService.translate('ATTENDEE_LIST.DIALOG.THIS_PHONE_CALLER');
                        } else {
                            attendeeName = attendeeName + self.getCallerAssignment(attendee);
                        }
                    }

                    var promptMsg = attendee.isPhoneUser
                        ? localizationService.translate('ATTENDEE_LIST.DIALOG.MUTE_PHONE_USER_MESSAGE')
                        : localizationService.translate('ATTENDEE_LIST.DIALOG.MUTE_NON_PHONE_USER_MESSAGE');

                    attendeeName = helperService.encodeHtml(attendeeName);
                    var promptTitle = localizationService.translate('ATTENDEE_LIST.DIALOG.MUTE_PERSON_QUESTION', {
                        name: attendeeName
                    });
                    var extendedType = attendee.isPhoneUser ? 'mute-phone' : 'mute-attendee';

                    if (helperService.isMobile()) {
                        promptTitle = promptTitle.replace('<br/>', ' ');

                        var callback = function (response) {
                            //1 = Yes
                            //2 = No
                            if (response === 1) {
                                attendeeService.toggleAudio(attendee.attendantId);
                            }
                        };
                        var customBtnNames = 'Yes,No';

                        helperService.mobileConfirm(promptMsg, promptTitle, callback, customBtnNames);
                    } else {
                        var swalOpts = {
                            title: '<span data-private>' + promptTitle + '</span>',
                            text: promptMsg,
                            type: 'warning',
                            showCancelButton: true,
                            showConfirmButton: true,
                            confirmButtonColor: brandingService.getBaseColor(),
                            cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                            confirmButtonText: localizationService.translate('COMMON.YES_TEXT'),
                            allowOutsideClick: true,
                            html: true
                        };

                        if (helperService.getIsRedesign()) {
                            var displayName = attendeeName;
                            if (!attendee.isPhoneUser && displayName.indexOf(' ') > 0) {
                                displayName = displayName.substring(0, displayName.indexOf(' '));
                            }

                            var closeButtonHtml =
                                '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                            swalOpts = {
                                title:
                                    closeButtonHtml +
                                    '<div data-private class="sweetalert-text-fix-size"> ' +
                                    promptTitle +
                                    '</div>',
                                text: '<div class="sweetalert-text-fix-size">' + promptMsg + '</div>',
                                showCancelButton: true,
                                showConfirmButton: true,
                                confirmButtonColor: brandingService.getBaseColor(),
                                cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                                confirmButtonText: localizationService.translate('COMMON.YES_TEXT'),
                                allowOutsideClick: true,
                                html: true,
                                imageUrl: 'img/redesign/modal/pop-up-pic-mute.svg',
                                customClass: 'mute-individual-modal auto-size',
                                extendedType
                            };

                            if (attendee.isPhoneUser || attendee.switchedToPhone || attendee.phoneMemberId) {
                                swalOpts.imageUrl = 'img/redesign/modal/pop-up-pic-mute-phone.svg';
                            }
                        }

                        $window.swal(swalOpts, function (confirmed) {
                            if (confirmed) {
                                attendeeService.toggleAudio(attendee.attendantId);
                                socketService.send({
                                    message: 'attendee-message',
                                    data: { type: 'force-audio-muted', to: attendee.attendantId }
                                });
                                analyticsWrapperService.eventTrack('Meeting - Attendee List - Talk Mute Attendee');
                            }
                        });
                    }
                } else if (self.isAttendeeSelf(attendee)) {
                    //If attendee muted, only they can unmute themself

                    // Check security setting
                    if (self.isUnmutingSelfAllowed() === false) {
                        return;
                    }

                    attendeeService.toggleAudio(attendee.attendantId);
                    analyticsWrapperService.eventTrack('Meeting - Attendee List - Talk Unmute');
                }
            }
        }

        function kickAttendee(attendee) {
            if (!self.isKickOptionEnabled(attendee) || !self.canKickAttendee(attendee)) {
                return;
            }

            var attendeeName = $filter('phoneFilter')(attendee.screenName);

            if (attendee.isPhoneUser) {
                if (!attendeeService.getIsPresenter()) {
                    attendeeName = localizationService.translate('ATTENDEE_LIST.DIALOG.THIS_PHONE_CALLER');
                } else {
                    attendeeName = attendeeName + self.getCallerAssignment(attendee);
                }
            }

            var encodedAttendeeName = helperService.encodeHtml(attendeeName);
            var promptTitle = localizationService.translate('ATTENDEE_LIST.DIALOG.KICK_PERSON_QUESTION', {
                name: encodedAttendeeName
            });

            if (helperService.isMobile()) {
                promptTitle = promptTitle.replace('<br/>', ' ');

                var callback = function (response) {
                    //1 = Yes
                    //2 = No
                    if (response === 1) {
                        attendeeService.kick(attendee.attendantId);
                        analyticsWrapperService.eventTrack('Meeting - Attendee List - Kick Attendee');
                    }
                };

                helperService.mobileConfirm('', promptTitle, callback, 'Yes,No');
            } else {
                if (helperService.getIsRedesign() === true) {
                    if (!helperService.getVDIRef().showContentsOnTopOfVideo) {
                        $rootScope.$broadcast('vdi-toggle-preview-video-visibility', true);
                    }
                    var closeButtonHtml =
                        '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                    $window.swal(
                        {
                            title: closeButtonHtml + '<span data-private>' + promptTitle + '</span>',
                            text: '',
                            showCancelButton: true,
                            showConfirmButton: true,
                            confirmButtonColor: brandingService.getBaseColor(),
                            cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                            confirmButtonText: localizationService.translate('COMMON.REMOVE_TEXT'),
                            allowOutsideClick: true,
                            imageUrl: 'img/redesign/modal/pop-up-pic-remove-contact.svg',
                            html: true
                        },
                        function (confirmed) {
                            if (confirmed) {
                                attendeeService.kick(attendee.attendantId);
                                analyticsWrapperService.eventTrack('Meeting - Attendee List - Kick Attendee');
                            }
                            if (!helperService.getVDIRef().showContentsOnTopOfVideo) {
                                $rootScope.$broadcast('vdi-toggle-preview-video-visibility', false);
                            }
                        }
                    );
                } else {
                    //TODO: REMOVE POST-REDESIGN
                    $window.swal(
                        {
                            title: promptTitle,
                            text: '',
                            type: 'warning',
                            showCancelButton: true,
                            showConfirmButton: true,
                            confirmButtonColor: brandingService.getBaseColor(),
                            cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                            confirmButtonText: localizationService.translate('COMMON.YES_TEXT'),
                            allowOutsideClick: true,
                            html: true
                        },
                        function (confirmed) {
                            if (confirmed) {
                                attendeeService.kick(attendee.attendantId);
                                analyticsWrapperService.eventTrack('Meeting - Attendee List - Kick Attendee');
                            }
                        }
                    );
                }
            }
        }

        function virtualAssistantClicked(attendee) {
            if (meetingService.e2eeEnabled()) {
                return;
            }

            if (!attendee.kickEnabled || !attendeeService.getIsHost()) {
                self.showVirtualAssistantMessage();
                return;
            }

            self.toggleDropdown(attendee.attendantId, null);

            $window.$('#attendee-' + attendee.attendantId).tooltip('hide');
        }

        function removeVirtualAssistant() {
            logService.log('called removeVirtualAssistant ...');

            if (!attendeeService.getIsHost()) {
                return;
            }

            const promptTitle = localizationService.translate('VIRTUAL_ASSISTANT.REMOVE_QUESTION');

            let options = {
                text: '',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonColor: brandingService.getBaseColor(),
                cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                allowOutsideClick: true,
                html: true
            };

            if (helperService.getIsRedesign() === true) {
                const closeButtonHtml =
                    '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                options = {
                    ...options,
                    title: closeButtonHtml + promptTitle,
                    confirmButtonText: localizationService.translate('COMMON.REMOVE_TEXT'),
                    imageUrl: 'img/redesign/modal/pop-up-pic-remove-contact.svg'
                };
            } else {
                //TODO: REMOVE POST-REDESIGN
                options = {
                    ...options,
                    title: promptTitle,
                    type: 'warning',
                    confirmButtonText: localizationService.translate('COMMON.YES_TEXT')
                };
            }

            $window.swal(options, confirmed => {
                if (!confirmed) {
                    return;
                }

                attendeeService.removeVirtualAssistant();
                analyticsWrapperService.eventTrack('Meeting - Attendee List - Removed Virtual Assistant');
            });
        }

        function showVirtualAssistantMessage() {
            analyticsWrapperService.eventTrack('Meeting - Attendee List - Show Virtual Assistant Message');

            if (helperService.getIsRedesign()) {
                $rootScope.$broadcast('show-modal', 'meetingSettings', 'virtual-assistant');
            } else {
                $rootScope.$broadcast('show-modal', 'virtualAssistantMessage');
            }
        }

        function isKickOptionEnabled(attendee) {
            if (attendee.isPhoneUser) {
                return self.isAttendeeConnected(attendee);
            }

            return true;
        }

        function canKickAttendee(attendee) {
            // has permission to kick
            if ((attendeeService.getIsHost() || attendeeService.getIsPresenter()) && meetingService.getMaxUsers() > 4) {
                // don't allow to kick self and host
                var isSelf = attendee.attendantId === attendeeService.getAttendantId();
                return attendee.attendeeType !== 'host' && !isSelf;
            }

            return false;
        }

        function openInvites() {
            self.inviteOpen = !self.inviteOpen;
            $timeout(function () {
                digest();
            }, 1000);
        }

        function emailInviteClick() {
            var subject = self.isWebinar()
                ? localizationService.translate('ATTENDEE_LIST.PLEASE_JOIN_WEBINAR')
                : localizationService.translate('ATTENDEE_LIST.PLEASE_JOIN_MEETING');

            // Build body
            var bodyNewLine = '%0A';

            var info = phoneConferenceService.getPhoneData();
            var phoneNumber = info.phoneNumberFree || info.phoneNumberToll;
            var pin = info.attendeePIN + '#';

            // Open email
            openMailto(subject, createInvitationBody(self.invite.meetingLink, pin, phoneNumber, bodyNewLine));
        }

        function openMailto(subject, body) {
            // Create mailto: string
            var mailto = 'mailto:?subject=' + subject + '&body=' + body;

            // Open mailto: string
            var ref = $window.open(mailto, '_blank');

            // Close on blur if tab created has an empty body
            ref.onblur = function () {
                if (ref.document.body.innerHTML === '') {
                    ref.close();
                }
            };

            ref.focus();
        }

        function copyInviteToClipboard() {
            var lineBreak = '\r\n';

            var info = phoneConferenceService.getPhoneData();
            var phoneNumber = info.phoneNumberFree || info.phoneNumberToll;
            var pin = info.attendeePIN + '#';

            var text = createInvitationBody(self.invite.meetingLink, pin, phoneNumber, lineBreak);
            self.copyTextToClipboard(text, {
                successCallback: meetingInfoCopySuccessSwal,
                errorCallback: meetingInfoCopyErrorSwal
            });
        }

        function createInvitationBody(meetingLink, pin, phoneNumber, newLine) {
            var invitationBody = [];
            invitationBody.push(
                self.isWebinar()
                    ? localizationService.translate('ATTENDEE_LIST.WEBINAR_URL', { param: meetingLink })
                    : localizationService.translate('ATTENDEE_LIST.MEETING_URL', { param: meetingLink }),

                localizationService.translate('ATTENDEE_LIST.JOIN_BY_PHONE', { param: ' ' + phoneNumber }),
                localizationService.translate('ATTENDEE_LIST.PIN', { param: ' ' + pin }),
                localizationService.translate('ATTENDEE_LIST.QUICK_DIAL', {
                    param: ' ' + phoneNumber + ',,' + pin.replace(/\s/g, '')
                })
            );
            return invitationBody.join(newLine);
        }

        // TODO: probably extract copyTextToClipboard to service?
        function onCopyTextToClipboard(e, data) {
            self.copyTextToClipboard(data.text, data.options);
        }

        function copyTextToClipboard(text, options) {
            var textArea = $window.document.createElement('textarea');

            //
            // *** This styling is an extra step which is likely not required. ***
            //
            // Why is it here? To ensure:
            // 1. the element is able to have focus and selection.
            // 2. if element was to flash render it has minimal visual impact.
            // 3. less flakyness with selection and copying which **might** occur if
            //    the textarea element is not visible.
            //
            // The likelihood is the element won't even render, not even a flash,
            // so some of these are just precautions. However in IE the element
            // is visible whilst the popup box asking the user for permission for
            // the web page to copy to the clipboard.
            //

            // Place in top-left corner of screen regardless of scroll position.
            textArea.style.position = 'fixed';
            textArea.style.top = 0;
            textArea.style.left = 0;

            // Ensure it has a small width and height. Setting to 1px / 1em
            // doesn't work as this gives a negative w/h on some browsers.
            textArea.style.width = '2em';
            textArea.style.height = '2em';

            // We don't need padding, reducing the size if it does flash render.
            textArea.style.padding = 0;

            // Clean up any borders.
            textArea.style.border = 'none';
            textArea.style.outline = 'none';
            textArea.style.boxShadow = 'none';

            // Avoid flash of white box if rendered for any reason.
            textArea.style.background = 'transparent';

            textArea.value = text;

            // In case of copying from modal window, need to add textArea inside the modal instead of document.body
            var parent = $window.document.body;
            if (options && options.parentElementId) {
                var parentElement = $window.document.getElementById(options.parentElementId);
                if (parentElement) {
                    parent = parentElement;
                }
            }
            parent.appendChild(textArea);

            textArea.focus();
            textArea.select();

            try {
                if ($window.document.execCommand('copy')) {
                    if (options && options.successCallback) {
                        options.successCallback();
                    }
                } else {
                    if (options && options.errorCallback) {
                        options.errorCallback();
                    }
                }
            } catch (err) {
                if (options && options.errorCallback) {
                    options.errorCallback();
                }
            }

            parent.removeChild(textArea);
        }

        function getVisibleAttendeeLoginUrl(meetingLink) {
            var result = meetingLink;

            var protocolIndex = result.indexOf('://');
            if (protocolIndex > -1) {
                result = result.substring(protocolIndex + 3);
            }

            var parametersIndex = result.indexOf('?');
            if (parametersIndex > -1) {
                result = result.substring(0, parametersIndex) + '...';
            }

            return result;
        }

        function meetingInfoCopySuccessSwal() {
            var notificationText = self.isWebinar()
                ? localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.COPY_WEBINAR_INFO_TO_CLIPBOARD')
                : localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.COPY_MEETING_INFO_TO_CLIPBOARD');
            growlService.show(notificationText, 'success');
        }

        function meetingInfoCopyErrorSwal() {
            var notificationText = self.isWebinar()
                ? localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.FAILED_COPY_WEBINAR_INFO_TO_CLIPBOARD')
                : localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.FAILED_COPY_MEETING_INFO_TO_CLIPBOARD');
            growlService.show(notificationText, 'danger');
        }

        function orderByHostsOnTopThenAlpha(attendee) {
            // Note: used for webinar only!
            if (attendee.attendeeType === 'host') {
                return 1 + attendee.screenName;
            } else if (attendee.attendeeType === 'bot' && attendee.botType === 'transcription') {
                return 2 + attendee.screenName;
            } else if (attendee.attendeeType === 'presenter') {
                return 3 + attendee.screenName;
            } else {
                return 4 + attendee.screenName;
            }
        }

        function isAttendeeSelf(attendee) {
            //Pins self to top, then orders alphabetically for everyone else
            if (attendee.attendantId === self.attendantId) {
                return true;
            } else {
                return false;
            }
        }

        function audioMuteAll() {
            // Check security setting
            if (self.isMutingOthersAllowed() === false) {
                return;
            }

            if (!helperService.browserHasWebRTC() || self.onAirModeUpdating) {
                return;
            }

            var promptTitle = localizationService.translate('ATTENDEE_LIST.DIALOG.MUTE_EVERYONE_QUESTION');
            var promptMsg = localizationService.translate('ATTENDEE_LIST.DIALOG.MUTE_EVERYONE_MESSAGE');

            if (helperService.isMobile()) {
                var callback = function (response) {
                    //1 = Yes
                    //2 = No
                    if (response === 1) {
                        attendeeService.audioMuteAll();
                        analyticsWrapperService.eventTrack('Meeting - Attendee List - Talk Mute All');
                    }
                };
                var customBtnNames = 'Yes,No';

                helperService.mobileConfirm(promptMsg, promptTitle, callback, customBtnNames);
            } else {
                if (helperService.getIsRedesign() === true) {
                    var closeButtonHtml =
                        '<button class="sweetalert-close-x" onclick="window.swal.close();" tabindex="3"><img src="img/redesign/icons/close-big.svg"></img></button>';
                    $window.swal(
                        {
                            title: closeButtonHtml + promptTitle,
                            text: '<div class="sweetalert-text-fix-size">' + promptMsg + '</div>',
                            showCancelButton: true,
                            showConfirmButton: true,
                            confirmButtonColor: brandingService.getBaseColor(),
                            cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                            confirmButtonText: localizationService.translate('ATTENDEE_LIST.DIALOG.YES_MUTE_EVERYONE'),
                            allowOutsideClick: true,
                            html: true,
                            imageUrl: 'img/redesign/modal/pop-up-pic-mute.svg',
                            customClass: 'mute-everyone-modal auto-size',
                            extendedType: 'mute-all'
                        },
                        function (confirmed) {
                            if (confirmed) {
                                attendeeService.audioMuteAll();
                                analyticsWrapperService.eventTrack('Meeting - Attendee List - Talk Mute All');
                            }
                        }
                    );
                } else {
                    //TODO: REMOVE POST-REDESIGN
                    $window.swal(
                        {
                            title: promptTitle,
                            text: promptMsg,
                            type: 'warning',
                            showCancelButton: true,
                            showConfirmButton: true,
                            confirmButtonColor: brandingService.getBaseColor(),
                            cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                            confirmButtonText: localizationService.translate('ATTENDEE_LIST.DIALOG.YES_MUTE_EVERYONE'),
                            allowOutsideClick: true,
                            html: true
                        },
                        function (confirmed) {
                            if (confirmed) {
                                attendeeService.audioMuteAll();
                                analyticsWrapperService.eventTrack('Meeting - Attendee List - Talk Mute All');
                            }
                        }
                    );
                }
            }
        }

        function getAudioStatusTooltip(attendee) {
            var firstName = attendee.screenName.split(' ')[0],
                isSelf = self.isAttendeeSelf(attendee),
                connectionState = self.getAttendeeConnectionState(attendee);

            if (helperService.getIsRedesign() && isSelf) {
                connectionState = connectivityService.getLocalConnectivityState();
            }

            if (self.isWebinar() && !attendeeService.getIsPresenter()) {
                return '';
            }

            if (self.onAirModeUpdating) {
                return 'Unable to mute while going on-air';
            }

            if (attendee.isPhoneUser) {
                if (!attendeeService.getIsPresenter()) {
                    firstName = self.getPhoneCallerDisplayName(attendee);
                } else {
                    firstName = firstName + self.getCallerAssignment(attendee);
                }
            }

            var disconnected = connectionState === 'disconnected';
            var connecting = connectionState === 'connecting';

            if (disconnected || connecting) {
                if (isSelf) {
                    return disconnected
                        ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.YOU_ARE_NOT_CONNECTED')
                        : localizationService.translate('ATTENDEE_LIST.TOOLTIP.YOU_ARE_CONNECTING');
                } else {
                    return disconnected
                        ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_ARE_NOT_CONNECTED', {
                              name: firstName
                          })
                        : localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_ARE_CONNECTING', {
                              name: firstName
                          });
                }
            }

            if (
                meetingService.isWebinar() &&
                !attendee.isMobileAppUser &&
                attendee.attendeeType === 'attendee' &&
                (attendee.isPhoneUser || attendee.hasWebRTC) &&
                isSelf !== true
            ) {
                return firstName + ' is only able to listen. Promote them to enable audio.';
            }

            if (attendee.hasWebRTC && attendee.switchedToPhone && !attendee.phoneMemberId) {
                return isSelf
                    ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.YOU_SWITCH_TO_PHONE', {
                          name: self.selfDisplayName
                      })
                    : localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_SWITCH_TO_PHONE', {
                          name: firstName
                      });
            }

            if (!attendee.hasWebRTC && !attendee.isPhoneUser) {
                return isSelf
                    ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.YOU_USE_NOT_CHROME_BROWSER', {
                          name: self.selfDisplayName
                      })
                    : localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_USE_NOT_CHROME_BROWSE', {
                          name: firstName
                      });
            }

            var micAvailable = attendee.devicePermissions.audioAllowed;
            //TODO: After next mobile release (version 2.1.5),
            //we can remove the check for isMobileAppUser
            if (attendee.deviceConnections && !attendee.isMobileAppUser) {
                if (attendee.devicePermissions.audioAllowed) {
                    //Only care about audioConnected state if audio device permissions are allowed
                    micAvailable = attendee.deviceConnections.audioConnected;
                }
            }

            if (!micAvailable && !attendee.isPhoneUser && !attendee.phoneMemberId) {
                return isSelf
                    ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.YOU_DO_NOT_HAVE_MIC', {
                          name: self.selfDisplayName
                      })
                    : localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_DO_NOT_HAVE_MIC', {
                          name: firstName
                      });
            }

            if (attendee.audioDisconnected) {
                return localizationService.translate('HEADER.SETTINGS.DISCONNECT_AUDIO');
            }

            if (!attendee.isSelfMuted) {
                if (!helperService.browserHasWebRTC()) {
                    if (isSelf) {
                        return localizationService.translate('ATTENDEE_LIST.TOOLTIP.YOU_UNMUTED', {
                            name: self.selfDisplayName
                        });
                    } else {
                        return localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_UNMUTED', {
                            name: firstName
                        });
                    }
                } else {
                    if (isSelf) {
                        return localizationService.translate('ATTENDEE_LIST.TOOLTIP.YOU_MUTE');
                    } else {
                        // Check security setting
                        if (self.isMutingOthersAllowed() === false) {
                            return localizationService.translate(
                                'ATTENDEE_LIST.TOOLTIP.HOST_HAS_DISABLED_THIS_FEATURE'
                            );
                        } else {
                            return localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_MUTE', {
                                name: firstName
                            });
                        }
                    }
                }
            } else {
                if (isSelf === true) {
                    // Check security setting
                    if (self.isUnmutingSelfAllowed() === false) {
                        return localizationService.translate('ATTENDEE_LIST.TOOLTIP.HOST_HAS_DISABLED_THIS_FEATURE');
                    } else {
                        return localizationService.translate('ATTENDEE_LIST.TOOLTIP.YOU_UNMUTE');
                    }
                } else {
                    if (attendee.isPhoneUser || attendee.phoneMemberId) {
                        return localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_MUTED_PHONE', {
                            name: firstName
                        });
                    } else {
                        return localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_MUTED', { name: firstName });
                    }
                }
            }
        }

        function getIndicatorTooltip(attendee, type) {
            var firstName = attendee.screenName.split(' ')[0],
                isSelf = self.isAttendeeSelf(attendee),
                tooltipMsg = '';

            var isWebinarAttendee = meetingService.isWebinar() && attendee.attendeeType === 'attendee';

            if (!attendeeService.getIsPresenter() && attendee.isPhoneUser) {
                firstName = self.getPhoneCallerDisplayName(attendee);
            }

            switch (type) {
                case 'webcam':
                    tooltipMsg = self.getWebcamTooltip(attendee);
                    break;

                case 'connectivity':
                    tooltipMsg = self.getIceConnectivityTooltip(attendee);
                    break;

                case 'slides':
                    tooltipMsg = isSelf
                        ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.YOU_SHARING_MEDIA')
                        : localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_SHARING_MEDIA', {
                              person: firstName
                          });
                    break;
                case 'video':
                    if (helperService.getIsRedesign()) {
                        tooltipMsg = isSelf
                            ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.YOU_SHARING_VIDEO')
                            : localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_SHARING_VIDEO', {
                                  person: firstName
                              });
                    } else {
                        tooltipMsg = isSelf
                            ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.YOU_SHARING_MEDIA')
                            : localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_SHARING_MEDIA', {
                                  person: firstName
                              });
                    }
                    break;

                case 'screenshare':
                    tooltipMsg = isSelf
                        ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.YOU_SHARING_SCREEN')
                        : localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_SHARING_SCREEN', {
                              person: firstName
                          });
                    break;

                case 'disconnected':
                    var meetingType = meetingService.isWebinar()
                        ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.MEETING_TYPE_WEBINAR')
                        : localizationService.translate('ATTENDEE_LIST.TOOLTIP.MEETING_TYPE_MEETING');

                    tooltipMsg = isSelf
                        ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.YOU_NOT_CONNECTED_TO_MEETING', {
                              meeting_type: meetingType
                          })
                        : localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_NOT_CONNECTED_TO_MEETING', {
                              person: firstName,
                              meeting_type: meetingType
                          });
                    break;
            }

            return tooltipMsg;
        }

        function getWebcamTooltip(attendee) {
            var firstName = attendee.screenName.split(' ')[0];
            var isSelf = self.isAttendeeSelf(attendee);
            var tooltip = '';

            if (!attendeeService.getIsPresenter() && attendee.isPhoneUser) {
                firstName = self.getPhoneCallerDisplayName(attendee);
            }

            if (attendee.hasVideo) {
                //Attendee has webcam

                if (attendee.devicePermissions.videoAllowed) {
                    //Attendee has allowed webcam permissions

                    if (attendee.isVideoMuted) {
                        //Attendee is not sharing webcam
                        tooltip = isSelf
                            ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.YOU_WEBCAM_OFF')
                            : localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_WEBCAM_OFF', {
                                  person: firstName
                              });
                    } else {
                        //Attendee is sharing webcam
                        tooltip = isSelf
                            ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.YOU_WEBCAM_ON')
                            : localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_WEBCAM_ON', {
                                  person: firstName
                              });
                    }
                } else {
                    //Attendee has blocked webcam permissions
                    tooltip = isSelf
                        ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.YOU_DO_NOT_HAVE_ACTIVE_WEBCAM')
                        : localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_DO_NOT_HAVE_ACTIVE_WEBCAM', {
                              person: firstName
                          });
                }
            } else {
                //Attendee does not have a webcam
                tooltip = isSelf
                    ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.YOU_DO_NOT_HAVE_ACTIVE_WEBCAM')
                    : localizationService.translate('ATTENDEE_LIST.TOOLTIP.PERSON_DO_NOT_HAVE_ACTIVE_WEBCAM', {
                          person: firstName
                      });
            }

            return tooltip;
        }

        function getIceConnectivityTooltip(attendee) {
            var firstName = attendee.screenName.split(' ')[0];
            var isSelf = self.isAttendeeSelf(attendee);

            if (!attendeeService.getIsPresenter() && attendee.isPhoneUser) {
                firstName = self.getPhoneCallerDisplayName(attendee);
            }

            if (isSelf) {
                var selfConnectivity = {
                    iceConnectionState: connectivityService.getLocalConnectivityState(),
                    packetLoss: {
                        state: connectivityService.getPacketLossState(),
                        streams: connectivityService.getStreams()
                    }
                };
                return connectivityService.getConnectivityTooltip(selfConnectivity, isSelf, firstName);
            }

            return connectivityService.getConnectivityTooltip(attendee.connectivity, isSelf, firstName);
        }

        //TODO: Consolidate this function with headerCtrl.getConnectivityIconState in a service
        //Currently unable to do so until we have connectivityService keep track of bandwidth (as opposed to vertoService)
        function getConnectivityIconState(attendee) {
            return connectivityService.getConnectivityIconState(attendee.connectivity);
        }

        function getConnectivityClass(attendee) {
            if (self.isAttendeeSelf(attendee)) {
                if (!connectivityService.isLocalConnectvityConnected()) {
                    return 'zmdi-wifi-off';
                }

                switch (connectivityService.getLocalConnectivityIconState()) {
                    case 'low':
                        return 'zmdi-wifi-alt low';
                    case 'medium':
                        return 'zmdi-wifi-alt-2 medium';
                    case 'high':
                        return 'zmdi-wifi-info high';
                }
            } else {
                if (!self.isAttendeeConnected(attendee)) {
                    return 'zmdi-wifi-off';
                }

                switch (self.getConnectivityIconState(attendee)) {
                    case 'low':
                        return 'zmdi-wifi-alt low';
                    case 'medium':
                        return 'zmdi-wifi-alt-2 medium';
                    case 'high':
                        return 'zmdi-wifi-info high';
                }
            }

            return 'zmdi-wifi-alt low';
        }

        // set or remove any style on the dropdown card, for the attendee.
        // if style is falsy, then remove the style attribute.
        function setDropdownCardStyle(attendantId, style) {
            // TODO: we should not use duplicate id of attendee-profile-card in DOM.
            var element = $window.$('[id="attendee-' + attendantId + '"] .dropdown #attendee-profile-card');
            if (element && element.length > 0) {
                if (style) {
                    element.attr('style', style);
                } else if (element.attr('style')) {
                    element.removeAttr('style');
                }
            }
        }

        // reset any video position style when dropdown is toggled from attendee list.
        // if previous existed, then reset on that previous too.
        function toggleDropdown(attendantId) {
            if (!self.hasProfileCardsEnabled()) {
                return;
            }

            if (self.dropdownId !== attendantId && self.dropdownId > 0) {
                setDropdownCardStyle(self.dropdownId);
            }
            setDropdownCardStyle(attendantId);

            toggleDropdownInternal(attendantId);
        }

        // this should be called only from one of the above three functions.
        function toggleDropdownInternal(attendantId) {
            if (self.dropdownId === attendantId) {
                self.dropdownId = 0;

                self.restoreProfileCardTooltip(attendantId);
            } else {
                if (self.dropdownId > 0) {
                    self.restoreProfileCardTooltip(self.dropdownId);
                }

                self.dropdownId = attendantId;

                self.hideProfileCardTooltip(attendantId);

                analyticsWrapperService.eventTrack(
                    'Meeting - Attendee List - Opened Contact Card (Info Not Populated)'
                );
            }
        }

        function onCloseProfileDropdown() {
            self.restoreProfileCardTooltip(self.dropdownId);

            self.dropdownId = 0;
            digest();
        }

        function hideProfileCardTooltip(attendantId) {
            var element = $window.$('[id="attendee-' + attendantId + '"] .dropdown .icon-container');
            element.tooltip('disable');
            element.tooltip('hide');
        }

        function restoreProfileCardTooltip(attendantId) {
            $window.$('[id="attendee-' + attendantId + '"] .dropdown.open .icon-container').tooltip('enable');
        }

        function promote(attendee) {
            if (attendee.isPhoneUser) {
                notificationService.show(localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.PROMOTE_USER'));
                //notificationService.show('Please wait while we are promoting your attendee.  They will momentarily disappear and reappear in the attendee list.', 'success');
            }

            var msgObj = {};
            msgObj.message = 'promote-attendee';
            msgObj.data = attendee.attendantId;
            socketService.send(msgObj);
        }

        function demote(attendee) {
            if (attendee.isPhoneUser) {
                notificationService.show(localizationService.translate('ATTENDEE_LIST.NOTIFICATIONS.DEMOTE_USER'));
                //notificationService.show('Please wait while we are demoting your attendee.  They will momentarily disappear and reappear in the attendee list.', 'success');
            }

            var msgObj = {};
            msgObj.message = 'demote-attendee';
            msgObj.data = attendee.attendantId;
            socketService.send(msgObj);
        }

        function isPromoteBlocked(attendee) {
            return !(attendee.hasWebRTC || attendee.isPhoneUser) || attendee.isMobileAppUser;
        }

        function getPromoteBlockedTooltip(attendee) {
            var firstName = attendee.screenName.split(' ')[0];

            if (!attendee.hasWebRTC && !attendee.isPhoneUser) {
                return localizationService.translate('ATTENDEE_LIST.TOOLTIP.PROMOTE_BLOCKED_UNSUPPORTED_BROWSER', {
                    person: firstName
                });
            }

            if (attendee.isMobileAppUser) {
                return localizationService.translate('ATTENDEE_LIST.TOOLTIP.PROMOTE_BLOCKED_MOBILE', {
                    person: firstName
                });
            }
            return localizationService.translate('ATTENDEE_LIST.TOOLTIP.PROMOTE_BLOCKED', { person: firstName });
        }

        function hasPromoteDemoteFunctionality() {
            if (meetingService.isWebinar() && (attendeeService.getIsHost() || attendeeService.getIsPresenter())) {
                return true;
            }
            return false;
        }

        function isMicEnabled(attendee) {
            if (!attendee) {
                logger.error('isMicEnabled', 'Unable to retrieve micEnabled status');
                return false;
            }

            if (self.onAirModeUpdating) {
                return false;
            }

            var attendeeMuted = attendee.isSelfMuted ? true : false;
            var audioAllowed = attendee.devicePermissions && attendee.devicePermissions.audioAllowed ? true : false;

            //TODO: After next mobile release (version 2.1.5),
            //we can remove the check for isMobileAppUser
            if (attendee.deviceConnections && !attendee.isMobileAppUser) {
                var audioDeviceConnected = attendee.deviceConnections.audioConnected ? true : false;
                return audioAllowed && audioDeviceConnected && !attendeeMuted;
            } else {
                //Old flow, for backwards compability
                return audioAllowed && !attendeeMuted;
            }
        }

        function isAttendeeConnected(attendee) {
            var connectionState = self.getAttendeeConnectionState(attendee);
            return connectionState === 'connected';
        }

        function getAttendeeConnectionState(attendee) {
            var connectionState;
            var stateToCheck;
            var fsStateRequired = false;
            var isWebinarAttendee = meetingService.isWebinar() && attendee.attendeeType === 'attendee';

            try {
                if (attendee.isPhoneUser) {
                    stateToCheck = attendee.connectivity.pstnState;
                } else if (isWebinarAttendee) {
                    var disconnectedIceConn =
                        attendee.connectivity.iceConnectionState === 'disconnected' ||
                        attendee.connectivity.iceConnectionState === 'failed' ||
                        attendee.connectivity.iceConnectionState === 'closed';

                    if (attendee.connectivity.iceConnectionState && !disconnectedIceConn) {
                        //Attendees connected to Edge Services should have their
                        //iceConnectionStates checked
                        stateToCheck = attendee.connectivity.iceConnectionState;
                    } else {
                        stateToCheck = 'disconnected';
                    }
                } else {
                    stateToCheck = attendee.connectivity.iceConnectionState;
                    fsStateRequired = true;
                }
            } catch (e) {
                logger.error('getAttendeeConnectionState', 'Unable to parse attendee connectivity state', e);
            }

            //WebRTC Browsers: stateToCheck = iceConnectionState
            //Possible states: 'connected', 'completed', 'failed', 'disconnected'
            //Note: 'new' and 'checking' are potential states, but we currently ignore those...
            //      leaving them here in case they get added
            //
            //Possible states: 'connecting', 'connected', 'disconnected'
            //
            //The HTML template only expects one of three states: 'connecting', 'connected', or 'disconnected'
            switch (stateToCheck) {
                case 'failed':
                case 'disconnected':
                case 'closed':
                    connectionState = 'disconnected';
                    break;
                case 'connected':
                case 'completed':
                    if (fsStateRequired) {
                        if (attendee.connectivity.fsState === 'connected') {
                            connectionState = 'connected';
                        } else {
                            //Still waiting for add-member event
                            connectionState = 'connecting';
                        }
                    } else {
                        connectionState = 'connected';
                    }

                    break;
                case 'new':
                case 'checking':
                case 'connecting':
                    connectionState = 'connecting';
                    break;
                default:
                    connectionState = 'disconnected';
            }

            if (!meetingService.isWebinar() && (connectionState == 'connected' || connectionState == 'disconnected')) {
                // if attendee exists with disconnected socket state, it means it is reconnecting.
                if (attendee.connectivity.socketState == 'disconnected') {
                    connectionState = 'connecting';
                }
            }

            return connectionState;
        }

        function canTogglePlayEntryExitSounds() {
            return attendeeService.getIsHost();
        }

        function getPlayEntryExitSoundsTooltip() {
            return self.playEntryExitSounds
                ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.ENTRY_EXIT_SOUNDS_OFF')
                : localizationService.translate('ATTENDEE_LIST.TOOLTIP.ENTRY_EXIT_SOUNDS_ON');
        }

        function togglePlayEntryExitSounds() {
            if (!attendeeService.getIsHost()) {
                logService.log('playEntryExitSounds will not be updated for not a host');
                return;
            }
            self.playEntryExitSounds = !self.playEntryExitSounds;
            logService.log('Sending new playEntryExitSounds val to server:', self.playEntryExitSounds);
            analyticsWrapperService.eventTrack('Meeting - Attendee List - Play-entry-exit-sound Button Toggled');
            socketService.send({
                message: 'set-play-entry-exit-sounds',
                data: {
                    playEntryExitSounds: self.playEntryExitSounds
                }
            });
        }

        function getAttendeeConnectingTooltip(attendee) {
            var connectionState = self.getAttendeeConnectionState(attendee);
            var firstName = attendee.screenName.split(' ')[0];
            var isSelf = self.isAttendeeSelf(attendee);
            var tooltipMsg = '';

            // show tooltip only when connecting...
            switch (connectionState) {
                case 'connecting':
                    var meetingType = self.isWebinar()
                        ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.MEETING_TYPE_WEBINAR')
                        : localizationService.translate('ATTENDEE_LIST.TOOLTIP.MEETING_TYPE_MEETING');
                    tooltipMsg = isSelf
                        ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.ATTENDEE_YOU_CONNECTING', {
                              person: self.selfDisplayName,
                              meeting_type: meetingType
                          })
                        : localizationService.translate('ATTENDEE_LIST.TOOLTIP.ATTENDEE_PERSON_CONNECTING', {
                              person: firstName,
                              meeting_type: meetingType
                          });
                    break;
                default:
                    tooltipMsg = '';
                    break;
            }

            return tooltipMsg;
        }

        function onOnAirModeUpdating() {
            self.onAirModeUpdating = true;
            digest();
        }

        function onOnAirModeUpdated() {
            self.onAirModeUpdating = false;
            digest();
        }

        function hasProfileCardsEnabled() {
            return !!(attendeeService.getIsPresenter() || self.hasFavoritesEnabled());
        }

        function getReactionCounts() {
            var attendees = attendeeListService.getAttendeeList();

            var reactionCounts = {
                fine: 0,
                thumbsup: 0,
                thumbsdown: 0,
                love: 0,
                sad: 0,
                laughter: 0,
                wow: 0,
                applause: 0
            };

            for (var i = 0; i < attendees.length; i++) {
                if (attendees[i] && attendees[i].attendeeType === 'attendee') {
                    var reaction = attendees[i].currentReaction;

                    if (reactionCounts.hasOwnProperty(reaction)) {
                        reactionCounts[reaction]++;
                    }
                }
            }

            return reactionCounts;
        }

        function onUpdateLocalJoinAudioMuted() {
            self.joinAudioMuted = meetingService.getJoinAudioMuted();
            digest();
        }

        function onPlayEntryExitSoundsUpdated(e, data) {
            self.playEntryExitSounds = data.playEntryExitSounds;
            playEntryExitSoundsInitialize = true;
            digest();
        }

        //TODO: REMOVE POST-REDESIGN
        function isJoinAudioMutedInitialized() {
            return meetingService.isJoinAudioMutedInitialized();
        }

        function getMeetingType() {
            return self.isWebinar() ? 'webinar' : 'meeting';
        }

        function isMutingOthersAllowed() {
            return meetingService.isAllowedByHostSecuritySettings('canMuteOthers') !== false;
        }

        function isUnmutingSelfAllowed() {
            return meetingService.isAllowedByHostSecuritySettings('canUnmuteAudio') !== false;
        }

        function getEmailInviteTooltip() {
            return self.isWebinar()
                ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.EMAIL_WEBINAR_INFO')
                : localizationService.translate('ATTENDEE_LIST.TOOLTIP.EMAIL_MEETING_INFO');
        }

        function getCopyToClipboardTooltip() {
            return self.isWebinar()
                ? localizationService.translate('ATTENDEE_LIST.TOOLTIP.COPY_WEBINAR_INFO')
                : localizationService.translate('ATTENDEE_LIST.TOOLTIP.COPY_MEETING_INFO');
        }

        function getCallerAssignment(attendee) {
            if (!attendee || !attendee.callerAssignment) {
                return '';
            }
            return attendee.callerAssignment > 0 ? ' (' + (parseInt(attendee.callerAssignment) + 1) + ')' : '';
        }

        /**
         * @returns {boolean}
         */
        function shouldShowHandRaiseCounter() {
            return handRaiseService.getHandRaiseAvailable() && handRaiseService.getRaisedHands()?.size > 0;
        }

        function setQualityBarsConfig(event, data) {
            qualityBarsConfig = { ...qualityBarsConfig, ...data };
            meetingService.setHasQualityBars(meetingService.getIsSfuEnabled() && qualityBarsConfig.enabled);
            digest();
        }

        /**
         * @param {Map} attendeeQualityList: indexed with attendantId and value of {qualityBars, quality}
         * @param {Object} qualityBarsData: quality bars value and metrics causing quality degradation
         * for each media being shared by the attendee.
         * {<attendeeId-1>: {audioTx: {}, videoTx: {}, videoRx: {}}, <attendeeId-2>: {audioTx: {}, videoTx: {}}}
         * @param {number} attendantId: attendee whose quality bars + tooltip is to be updated, if not present then update quality bars + tooltip for all attendees
         */
        function onUpdateAttendeesQuality(e, attendeeQualityList, qualityBarsData, attendantId) {
            // if attendantId is present then update quality and tooltip only for that attendant
            // else update quality and tooltip for all attendants
            if (attendantId) {
                const attendee = attendeeListService.findAttendee(attendantId);
                if (attendee) {
                    updateQuality(attendee, attendeeQualityList, qualityBarsData);
                }
            } else {
                self.attendees.forEach(attendee => {
                    updateQuality(attendee, attendeeQualityList, qualityBarsData);
                });
            }
            attendeeListStateService.attendees = self.attendees;
            qualityBarsDataLastReceived = JSON.parse(JSON.stringify(qualityBarsData));
            digest();
        }

        function updateQuality(attendee, attendeeQualityList, qualityBarsData) {
            if (attendeeQualityList.has(attendee.attendantId)) {
                updateQualityValueAndTooltip(attendee, attendeeQualityList.get(attendee.attendantId), qualityBarsData);
            }
        }

        function updateQualityValueAndTooltip(attendee, { qualityBars, quality }, qualityBarsData) {
            const attendantId = attendee.attendantId;
            if (qualityBars != attendee.qualityBarsValue) {
                if (isQualityBarAutoHideEnabled() && qualityBars >= qualityBarsConfig.autoHideCutoff) {
                    // When quality bars value is greater than or equal to autoHideCutoff, keep it showing only for brief interval of time
                    // Do nothing if the previous quality value was also greater than or equal to autoHideCutoff
                    const qualityBarsValue = parseFloat(attendee.qualityBarsValue);
                    if (isNaN(qualityBarsValue) || qualityBarsValue < qualityBarsConfig.autoHideCutoff) {
                        showQualityForBriefTime(attendee);
                    }
                } else {
                    setShowQualityBars(attendee, qualityBars !== undefined && qualityBars !== null);
                    if (qualityBarAutoHideTimers[attendantId]) {
                        $timeout.cancel(qualityBarAutoHideTimers[attendantId]);
                        qualityBarAutoHideTimers[attendantId] = null;
                    }
                }
                attendee.qualityBarsValue = qualityBars === undefined || qualityBars === null ? '' : '' + qualityBars;
                updateAttendeeQualityTooltip(attendee, quality, qualityBarsData[self.attendantId]);
            } else if (
                qualityBarsData[attendee.attendantId] &&
                (!helperService.isObjectEqual(
                    qualityBarsData[attendee.attendantId],
                    qualityBarsDataLastReceived[attendee.attendantId]
                ) ||
                    !helperService.isObjectEqual(
                        qualityBarsData[self.attendantId],
                        qualityBarsDataLastReceived[self.attendantId]
                    ))
            ) {
                // Handles the case where quality value is same but the metrics change
                updateAttendeeQualityTooltip(attendee, quality, qualityBarsData[self.attendantId]);
            }
        }

        /**
         * @param {Object} attendee
         * @param {number} quality: quality in percentage
         * @param {Object} selfQualityData: contains self quality data of each media sent and received
         */
        function updateAttendeeQualityTooltip(attendee, quality, selfQualityData) {
            // qualityBarsData has all the metrics affecting the quality of media
            /**
             * audioTx: { LOSS: 50% },
             * videoTx: { DELAY: 300ms, JITTER: 100ms },
             * videoRx: { AVAILABLE_BITRATE: 120% }
             */
            let qualityBarsData = {};
            if (attendee.attendantId !== self.attendantId) {
                qualityBarsData = {
                    ...attendee?.qualityBars?.data
                };
                // Copy Rx data from self to qualityBarsData
                if (selfQualityData?.videoRx?.[attendee.attendantId]) {
                    qualityBarsData.videoRx = { ...selfQualityData?.videoRx?.[attendee.attendantId] };
                }
                if (selfQualityData?.screenRx?.[attendee.attendantId]) {
                    qualityBarsData.screenRx = { ...selfQualityData?.screenRx?.[attendee.attendantId] };
                }
            } else {
                // for self
                qualityBarsData = JSON.parse(JSON.stringify(selfQualityData));
                delete qualityBarsData.videoRx;
                delete qualityBarsData.screenRx;
            }
            const tooltipItems = [];
            const shortTooltipItems = [];
            if (qualityBarsData) {
                const qualityBarPercentageText = `${localizationService.translate('QUALITY_BARS.QUALITY')} ${Math.round(
                    quality * 100
                )}%`;
                tooltipItems.push(qualityBarPercentageText);
                if (qualityBarsData.cpuUsage) {
                    const cpuUsageText = `${localizationService.translate('CPU_USAGE')} ${qualityBarsData.cpuUsage}%`;
                    tooltipItems.push(cpuUsageText);
                }
                Object.keys(qualityBarsData).map(media => {
                    const mediaDataKeys = Object.keys(qualityBarsData[media]);
                    if (
                        mediaDataKeys.length > 1 ||
                        (mediaDataKeys.length === 1 && mediaDataKeys[0] !== 'qualityBars')
                    ) {
                        mediaDataKeys.map(metric => {
                            if (metric !== 'qualityBars' && metric !== 'quality') {
                                const { tooltipItem, shortTooltipItem } = createQualityBarsTooltipForMetric(
                                    media,
                                    metric,
                                    qualityBarsData
                                );
                                tooltipItems.push(tooltipItem);
                                if (shortTooltipItem) {
                                    shortTooltipItems.push(shortTooltipItem);
                                }
                            }
                        });
                    }
                });
            }
            let tooltip = tooltipItems.join('\n');
            logger.log(
                'updateAttendeeQualityTooltip',
                `Detailed quality tooltip for ${attendee.attendantId} is ${tooltip}`
            );
            let shortTooltip = shortTooltipItems.slice(0, 3).join(', ');
            shortTooltip = shortTooltip.charAt(0).toLocaleUpperCase() + shortTooltip.slice(1);
            if (qualityBarsConfig.shortTooltips) {
                tooltip = shortTooltip;
            }
            const qualityIcon = $(`#quality-bars-${attendee.attendantId}`);
            if (qualityIcon) {
                // add tooltip event listerners to detect if tooltip is shown
                if (!qualityIcon.data('listenersAttached')) {
                    qualityIcon.data('listenersAttached', true);
                    qualityIcon.on('show.bs.tooltip', function () {
                        qualityIcon.data('tooltip', true);
                    });
                    qualityIcon.on('hidden.bs.tooltip', function () {
                        qualityIcon.data('tooltip', false);
                    });
                }

                if (tooltip !== self.attendeeQualityTooltip[attendee.attendantId]) {
                    // It returns true if tooltip is open, and false if closed.
                    let show = qualityIcon.data('tooltip');
                    if (show) {
                        if (tooltip === '') {
                            // hide tooltip when there is nothing to display. This happens when quality is greater than autoHideCutoff.
                            qualityIcon.tooltip('hide');
                        } else {
                            // update tooltip contents
                            qualityIcon.attr('data-original-title', tooltip).tooltip('fixTitle').tooltip('show');
                        }
                    }
                }
            }
            self.attendeeQualityTooltip[attendee.attendantId] = tooltip;
            attendeeListStateService.attendeeQualityTooltip = self.attendeeQualityTooltip;
            if (attendee.attendantId === self.attendantId && self.isAttendeeConnected(attendee)) {
                $rootScope.$broadcast('self-quality-data-updated', {
                    qualityData: { value: attendee.qualityBarsValue, tooltip }
                });
            }
        }

        function createQualityBarsTooltipForMetric(media, metric, qualityBarsData) {
            const MEDIA = media.toUpperCase();
            const tooltipItem = localizationService.translate(`QUALITY_BARS.${MEDIA}.${metric}`, {
                value: Math.round(qualityBarsData[media][metric])
            });

            if (!qualityBarsConfig.shortTooltips) {
                return { tooltipItem };
            }

            const shortTooltipItem = localizationService.translate(`QUALITY_BARS.USER_FRIENDLY.${MEDIA}.${metric}`, {
                adjective: getTooltipMetricAdjective(media, metric, Math.round(qualityBarsData[media][metric]) / 100)
            });

            return { tooltipItem, shortTooltipItem };
        }

        function getTooltipMetricAdjective(media, metric, value) {
            let adjective;
            const cutoff = qualityBarsConfig.tooltipCutoff[media];
            switch (metric) {
                case 'LOSS':
                    adjective = value > cutoff.loss ? 'HIGH' : 'SOME';
                    break;
                case 'JITTER': {
                    adjective = value > cutoff.jitter ? 'HIGH' : 'SOME';
                    break;
                }
                case 'DELAY': {
                    adjective = value > cutoff.delay ? 'EXCESSIVE' : 'HIGH';
                    break;
                }
                case 'AVAILABLE_BITRATE': {
                    adjective = value > cutoff.availableBitrate ? 'VERY_POOR' : 'POOR';
                    break;
                }
                case 'DESIRED_BITRATE': {
                    adjective = value > cutoff.desiredBitrate ? 'POOR' : 'VERY_POOR';
                    break;
                }
            }
            return adjective ? localizationService.translate(`QUALITY_BARS.${adjective}`) : '';
        }

        // when user opens side bar, quality bar for all attendee should be visible for configured time
        // irrespective of the quality value
        function showQualityBarsForAllAttendees(event, data) {
            if (isQualityBarAutoHideEnabled()) {
                if (data === 'open') {
                    self.attendees.forEach(attendee => {
                        if (parseFloat(attendee.qualityBarsValue) >= qualityBarsConfig.autoHideCutoff) {
                            showQualityForBriefTime(attendee);
                        }
                    });
                }
            }
        }

        function showQualityForBriefTime(attendee) {
            if (qualityBarsConfig.autoHide === 0) {
                attendee.showQualityBars = false;
                return;
            }
            setShowQualityBars(attendee, true);
            // qualityBarsConfig.autoHide will be always a number
            const hideTimeout = qualityBarsConfig.autoHide * 1000;
            qualityBarAutoHideTimers[attendee.attendantId] = $timeout(function () {
                setShowQualityBars(attendee, false);
                qualityBarAutoHideTimers[attendee.attendantId] = null;
                digest();
            }, hideTimeout);
        }

        function isQualityBarAutoHideEnabled() {
            return qualityBarsConfig.autoHide !== false;
        }

        function setShowQualityBars(attendee, value) {
            attendeeListService.updatePartialProperty({
                attendantId: attendee.attendantId,
                propName: 'showQualityBars',
                propValue: value
            });
        }

        function onNodeDisconnected() {
            self.isNodeDisconnected = true;
            digest();
        }

        function onNodeReconnected() {
            self.isNodeDisconnected = false;
            self.disableJoinRequestInProgress = false;
            self.acceptAllJoinRequestsInProgress = false;
            digest();
        }

        function onCompactModeReceived(e, data) {
            self.isInCompactMode = data;
        }

        function digest() {
            $scope.$applyAsync();
        }

        function showAttendeeWithEchoDetectedModal(attendee) {
            if (self.modalsAvailable) {
                modalHelperService.openAttendeeWithEchoDetectedModal(attendee.screenName, attendee.attendantId);
            } else {
                $rootScope.$broadcast('show-modal', {
                    modalName: 'attendeeWithEchoDetected',
                    attendantName: attendee.screenName,
                    attendantId: attendee.attendantId
                });
            }
        }

        function toggleAttendeeFavorite(attendee) {
            const attendantId = attendee.attendantId;
            if (self.attendeeFavoritesList[attendantId] && self.attendeeFavoritesList[attendantId] !== false) {
                self.attendeeFavoritesList[attendantId] = false;
                self.broadcastToggleAttendeeAsFavoriteEvent(attendantId, false);
                analyticsWrapperService.eventTrack('Meeting - Attendee List - User unfavorited an attendee');
            } else {
                self.attendeeFavoritesList[attendantId] = true;
                self.broadcastToggleAttendeeAsFavoriteEvent(attendantId, true);
                analyticsWrapperService.eventTrack('Meeting - Attendee List - User favorited an attendee');
            }
            attendeeListStateService.favoritesList = self.attendeeFavoritesList;
            const tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);

            cookieService.putObject(
                'attendee-favorites-' + meetingService.getMeetingCode(),
                self.attendeeFavoritesList,
                {
                    expires: tomorrow,
                    secure: true,
                    samesite: 'strict'
                }
            );
        }

        function broadcastToggleAttendeeAsFavoriteEvent(attendantId, shouldPin) {
            $rootScope.$broadcast('toggle-attendee-as-favorite', { attendantId: attendantId, shouldPin: shouldPin });
        }

        function canTurnOffScreenshare(attendee) {
            return (
                meetingService.getIsSfuEnabled() &&
                attendeeService.getIsHost(true) &&
                (attendee.hasScreenVideo || attendee.attendantId == contentService.getContentOwner())
            );
        }

        function turnOffScreenshare(attendee) {
            if (self.canTurnOffScreenshare(attendee)) {
                if (attendee.attendantId == contentService.getContentOwner()) {
                    contentService.stopCurrentContent();
                }
                if (attendee.hasScreenVideo) {
                    socketService.send({
                        message: 'attendee-message',
                        data: { type: 'force-video-muted', to: attendee.attendantId, screen: true }
                    });
                }
                analyticsWrapperService.eventTrack('Meeting - Attendee List - Turn screenshare off');
            } else {
                logService.log('cannot turn off screenshare anymore for attendee=' + attendee.attendantId);
            }
        }

        function canTurnOffWebcam(attendee) {
            return (
                meetingService.getIsSfuEnabled() &&
                attendeeService.getIsHost(true) &&
                attendee.hasVideo &&
                !attendee.isVideoMuted
            );
        }

        function turnOffWebcam(attendee) {
            if (self.canTurnOffWebcam(attendee)) {
                socketService.send({
                    message: 'attendee-message',
                    data: { type: 'force-video-muted', to: attendee.attendantId }
                });
                analyticsWrapperService.eventTrack('Meeting - Attendee List - Turn webcam off');
            } else {
                logService.log('cannot turn off webcam anymore for attendee=' + attendee.attendantId);
            }
        }

        function getMuteAllTooltip() {
            let translationKey;
            // Check security setting
            if (self.isMutingOthersAllowed() === false) {
                translationKey = 'ATTENDEE_LIST.TOOLTIP.HOST_HAS_DISABLED_THIS_FEATURE';
            } else {
                translationKey = !helperService.browserHasWebRTC()
                    ? 'ATTENDEE_LIST.TOOLTIP.BROWSER_DOES_NOT_SUPPORT_FEATURE'
                    : self.onAirModeUpdating
                    ? 'ATTENDEE_LIST.TOOLTIP.ON_AIR_UPDATING'
                    : 'ATTENDEE_LIST.TOOLTIP.MUTE_ALL';
            }
            return localizationService.translate(translationKey);
        }

        function onUrlInfoContainerClick(data) {
            navigator.clipboard.writeText(data).then(
                () => {
                    const notificationMsg = localizationService.translate('NOTIFICATIONS.COPIED_TO_CLIPBOARD');
                    if (helperService.getDeviceType() === 'iPad') {
                        helperService.mobileAlert(notificationMsg, null, '');
                    } else {
                        growlService.show(notificationMsg, 'success');
                    }
                },
                err => logger.error('onUrlInfoContainerClick', 'Could not copy text', err)
            );
            analyticsWrapperService.eventTrack('Meeting - Invite - Copied URL', {
                category: 'Invite more people'
            });
        }

        function onPhoneInfoContainerClick(data) {
            navigator.clipboard.writeText(data).then(
                () => {
                    const notificationMsg = localizationService.translate('NOTIFICATIONS.COPIED_TO_CLIPBOARD');
                    if (helperService.getDeviceType() === 'iPad') {
                        helperService.mobileAlert(notificationMsg, null, '');
                    } else {
                        growlService.show(notificationMsg, 'success');
                    }
                },
                err => logger.error('onPhoneInfoContainerClick', 'Could not copy text', err)
            );
            analyticsWrapperService.eventTrack('Meeting - Invite - Copied Phone', {
                category: 'Invite more people'
            });
        }
    }
]);
